import { CSSProperties, ReactNode, forwardRef } from 'react';

import './Button.scoped.scss';

interface Props {
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  outlined?: boolean;
  round?: boolean;
  social?: boolean;
  desperate?: boolean;
  icon?: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export type Ref = HTMLButtonElement;

const Button = forwardRef<Ref, Props>((props, ref) => {
  const {
    style,
    icon,
    children,
    onClick,
    outlined = false,
    desperate = false,
    social = false,
    round = false,
    disabled = false,
  } = props;

  return (
    <button
      ref={ref}
      className={`${outlined ? 'outlined' : ''} ${desperate ? 'desperate' : ''} ${
        social ? 'social' : ''
      } ${round ? 'round' : ''} theme-button pointer`}
      style={{ ...style }}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={`${social ? 'social' : ''} ${icon ? 'icon' : ''}`}>{children}</div>
    </button>
  );
});

export default Button;
